export const ONE_DAY = 1000 * 60 * 60 * 24;

export const BottomIndent = {
  0: '',
  1: '11rem',
  2: '12.5rem',
  3: '14rem',
  4: '15.5rem',
};
